import React, {Component} from 'react';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Skeleton from "../../components/Skeleton/Skeleton";
import {connect} from "react-redux";
import {REQUEST_PRESS_RELEASES_DATA} from "../../actions/pressReleasesActions";
import ContentPage from "../../components/ContentPage/ContentPage";

const mapStateToProps = state => {
  return {
    pressReleases: state.pressReleasesData
  };
};

const mapDispatchToProps = dispatch => ({
  getPressReleasesData: () => dispatch({type: REQUEST_PRESS_RELEASES_DATA})
});


class PressReleaseItem extends Component {
  
  componentDidMount() {
    if (!Object.keys(this.props.pressReleases).length) {
      this.props.getPressReleasesData();
    }
  };
  
  render() {
    return (
      <div className="wrapper">
        <Breadcrumbs/>
        {
          Object.keys(this.props.pressReleases).length ? (
            <ContentPage
              content={this.props.pressReleases}
              arrayName="pressReleases"
              redirectPath="/about/press-releases"
            />
          ) : <Skeleton type="IFRAME"/>
        }
      </div>
    )
  }
}

export default (connect(mapStateToProps, mapDispatchToProps)(PressReleaseItem));



// WEBPACK FOOTER //
// ./src/pages/About/PressReleaseItem.js